import { useRequest } from 'utils/useFetch';

import request from '../../../utils/useAxios';
import {
  UUCAFE_NEWS_DETAIL_ADD_FAIL,
  UUCAFE_NEWS_DETAIL_ADD_REQUEST,
  UUCAFE_NEWS_DETAIL_ADD_SUCCESS,
  UUCAFE_NEWS_DETAIL_FAIL,
  UUCAFE_NEWS_DETAIL_REQUEST,
  UUCAFE_NEWS_DETAIL_SUCCESS,
  UUCAFE_NEWS_DETAIL_UPDATE_FAIL,
  UUCAFE_NEWS_DETAIL_UPDATE_REQUEST,
  UUCAFE_NEWS_DETAIL_UPDATE_SUCCESS,
  UUCAFE_NEWS_LIST_FAIL,
  UUCAFE_NEWS_LIST_REQUEST,
  UUCAFE_NEWS_LIST_SUCCESS,
} from '../../constants/data/uuCafeNewsConstants';

/*
* @Params
* {
  "page": 0,
  "page_size": 0,
  "type": 0,
  "order": "string",
  "order_by": "string",
  "keyword": "string"
  }
*
*/
export const getCafeNewsList = data => {
  return async (dispatch, getState) => {
    await useRequest({
      data,
      dispatch,
      failConstant: UUCAFE_NEWS_LIST_FAIL,
      method: 'post',
      requestConstant: UUCAFE_NEWS_LIST_REQUEST,
      successConstant: UUCAFE_NEWS_LIST_SUCCESS,
      url: '/Backend/Cafe_Info/news/list',
    });
  };
};

export const getCafeNewsDetail = params => {
  return async (dispatch, getState) => {
    await useRequest({
      dispatch,
      failConstant: UUCAFE_NEWS_DETAIL_FAIL,
      method: 'get',
      requestConstant: UUCAFE_NEWS_DETAIL_REQUEST,
      successConstant: UUCAFE_NEWS_DETAIL_SUCCESS,
      url: `/Backend/Cafe_Info/news/${params.id}`,
    });
  };
};

/*
* @Params
id integer($int32)
title string
title_en string
content string
content_en string
startTime string($date-time)
endTime string($date-time)
img_files array
*/
export const addCafeNewsDetail = data => {
  return async (dispatch, getState) => {
    await useRequest({
      data,
      dispatch,
      failConstant: UUCAFE_NEWS_DETAIL_ADD_FAIL,
      method: 'post',
      requestConstant: UUCAFE_NEWS_DETAIL_ADD_REQUEST,
      successConstant: UUCAFE_NEWS_DETAIL_ADD_SUCCESS,
      url: '/Backend/Cafe_Info/news/add',
    });
  };
};

export const updateCafeNewsDetail = data => {
  return async (dispatch, getState) => {
    await useRequest({
      data,
      dispatch,
      failConstant: UUCAFE_NEWS_DETAIL_UPDATE_FAIL,
      method: 'post',
      requestConstant: UUCAFE_NEWS_DETAIL_UPDATE_REQUEST,
      successConstant: UUCAFE_NEWS_DETAIL_UPDATE_SUCCESS,
      url: '/Backend/Cafe_Info/news/update',
    });
  };
};

/*
  @params
  data:
  id: integer($int32)
*/
export const deleteCafeNewsDetail =  async (params) => {
  return await request({
    method: 'get',
    params,
    url: '/Backend/Cafe_Info/news/delete',
  });

};
